import initializeArticleRelatedContents from "./common/initializeArticleRelatedContents";
import initializeBaseData from "./common/initializeBaseData";
import initializeBookmarkBtn from "./common/initializeBookmarkBtn";
import initializeCurrentUserMsg from "./common/initializeCurrentUserMsg";
import initializeDisplayGoogleMap from "./common/initializeDisplayGoogleMap";
import "./common/initializeEnvBarScrollEffect";
import initializeFollowBtn from "./common/initializeFollowBtn";
import initializeGuideForCompanyPopup from "./common/initializeGuideForCompanyPopup";
import initializeNotificationMailSetting from "./common/initializeNotificationMailSetting";
import initializeRelatedUsers from "./common/initializeRelatedUsers";
import "./common/initializeSearchHistory";
import initializeStoryInfo from "./common/initializeStoryInfo";
import initializeSupportButtonLabel from "./common/initializeSupportButtonLabel";
import initializeUserPresenceSummary from "./common/initializeUserPresenceSummary";
import initializePcBaseData from "./pc/initializePcBaseData";
import { enableGtmArticleAlgorithmTracking } from "../common/functions/gtm";
import { enableGtmEcommerceTracking } from "../common/functions/gtmEcommerce";

window.onload = () => {
  if (document.querySelector("body.articles.show")) {
    initializeUserPresenceSummary();
  }
  initializeBaseData().then((json) => {
    initializePcBaseData(json);
    initializeSupportButtonLabel(json.current_person);
  });

  // initializeRelatedArticles(); // NOTE: initializeArticleRelatedContentsに移行したが本番環境の速度次第で戻すため、残しておく
  initializeArticleRelatedContents();
  initializeRelatedUsers().then(() => {
    initializeFollowBtn();
  });
  // initializeRelatedStories(); // NOTE: initializeArticleRelatedContentsに移行したが本番環境の速度次第で戻すため、残しておく
  // initializeUsersArticles(); // NOTE: initializeArticleRelatedContentsに移行したが本番環境の速度次第で戻すため、残しておく
  initializeBookmarkBtn();
  initializeStoryInfo(Routes);
  initializeGuideForCompanyPopup();
  initializeDisplayGoogleMap();
  if (
    document.querySelector("body.reg_users.show, body.reg_users.show_article")
  ) {
    initializeCurrentUserMsg();
  }
};

window.addEventListener("react_rendering", () => {
  initializeNotificationMailSetting();
  initializeBookmarkBtn();
});
enableGtmArticleAlgorithmTracking();
enableGtmEcommerceTracking();
